import { render, staticRenderFns } from "./VInput.vue?vue&type=template&id=f537d382&scoped=true"
import script from "./VInput.vue?vue&type=script&lang=js"
export * from "./VInput.vue?vue&type=script&lang=js"
import style0 from "./VInput.vue?vue&type=style&index=0&id=f537d382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f537d382",
  null
  
)

export default component.exports